export default __webpack_public_path__ + "static/media/nbaLandingPageCoverMobile.9f9fc44c.png";